import React from 'react';
import type { FC } from 'react';
import { Spinner, useAsync } from '@wix/cli-ui-kit';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { match } from 'variant';
import {
  reportLoginFailure,
  reportLoginStart,
  reportLoginSuccess,
} from '../login-bi.js';
import { apiKeyAuthStrategy } from '../auth-strategies/index.js';
import type { AuthStrategyState } from '../auth-strategies/index.js';

interface Props {
  token: string;
  onLogin: (data: AuthStrategyState) => void;
  onError: (error: unknown) => void;
}

export const ApiKeyLogin: FC<Props> = ({ token, onLogin, onError }) => {
  const biLogger = useBiLogger();

  const { status } = useAsync(
    async () => {
      reportLoginStart(biLogger);

      return apiKeyAuthStrategy.login({ token });
    },
    [],
    {
      onSuccess: (authData) => {
        reportLoginSuccess(biLogger, authData.userInfo);
        onLogin(authData);
      },
      onError: (error) => {
        reportLoginFailure(biLogger, error);

        onError(error);
      },
    }
  );

  return match(status, {
    Error: () => null,
    Loading: () => <Spinner />,
    Success: () => null,
  });
};
